import { Fragment } from "react";
import SearchOrCreateSelectInput from "../../core/inputs/SearchOrCreateSelectInput";
import { formatLocalTime } from "../../core/utils/utils";

function getEstimateObjectLabel(estimate, preferredTimezone) {
    return <Fragment>
        <span><strong>{`${estimate.custom_id || estimate.id} (${estimate.status_label})`}</strong><br></br></span>
        <span className="select-label-secondary-level"><em>{estimate.service_name}</em><br></br></span>
        {estimate.date_issued && <span className="select-label-secondary-level">{formatLocalTime(estimate.date_issued, preferredTimezone, false, false, false, true).localDateString}</span>}
    </Fragment>
}

function estimateToEstimateOption(estimate, preferredTimezone) {
    return { value: estimate.id, label: getEstimateObjectLabel(estimate, preferredTimezone), object: estimate }
}

function EstimateSearchOrCreateSelect(props) {
    const { preferredTimezone } = props

    return <SearchOrCreateSelectInput
        objectName="Estimate"
        getObjectLabel={(estimate) => getEstimateObjectLabel(estimate, preferredTimezone)}
        listEndpoint={DjangoUrls["estimates:api-estimates-search"](window.MARKETPLACE_ENTITY_SLUG)}
        listEndpointKwargs={[["ordering", "status,-date_issued"]]}
        getDetailsEndpoint={(estimate) => DjangoUrls["estimates:api-estimates-detail"](window.MARKETPLACE_ENTITY_SLUG, estimate.id)}
        {...props}
    />
}

export { estimateToEstimateOption };
export default EstimateSearchOrCreateSelect
